import { Link } from 'react-router-dom';
import { useModal } from '../context/ModalContext';
import { useBrightSaaSStarField } from '../hooks/useBrightSaaSStarField';

export function HomePage() {
  const { open } = useModal();
  useBrightSaaSStarField();
  return (
    <>
      <header className="nk-header" id="home">
        <div className="nk-hero flex-grow-1 d-flex flex-column">
          <div className="nk-hero-content py-10 pt-lg-27 pb-lg-31 my-auto">
            <div className="container">
              <div className="row align-items-center justify-content-center justify-content-lg-between gy-6">
                <div className="col-md-10 col-lg-6 col-xl-6 order-lg-1">
                  <div className="nk-hero-image ps-lg-10 has-mask overflow-hidden">
                    <img src="/marketing/landing/header.png" alt="hero" />
                  </div>
                </div>
                <div className="col-md-10 col-lg-6 col-xl-6">
                  <div className="nk-hero-content text-center text-lg-start">
                    {/*<div className="fs-9 text-uppercase text-gradient-a w-max mw-100 mb-3 mx-auto ms-lg-0 me-lg-auto">*/}
                    {/*  Yapamar*/}
                    {/*</div>*/}
                    <h1 className="nk-hero-title text-gradient-heading fw-medium mb-4">
                      {' '}
                      Marketing Mix Modeling <br /> &amp; Budget Intelligence{' '}
                    </h1>
                    <p className="lead mb-8">
                      Stop guessing where your budget actually works. Yapamar
                      models every channel that drives your sales — including
                      what clicks can&rsquo;t see: TV, radio, print, outdoor,
                      and the seasons, holidays, and economic swings around
                      them. Plan with evidence, not gut feeling.
                    </p>
                    <ul className="nk-list-inline justify-content-center justify-content-lg-start gap-6">
                      <li>
                        {' '}
                        <button
                          type="button"
                          onClick={() =>
                            open('contact', {
                              title: 'Start Modeling',
                              submitText: 'Submit Application',
                            })
                          }
                          className="btn btn-outline-light btn-lg">
                          {' '}
                          Start Modeling{' '}
                        </button>{' '}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="gradient-separator mt-10 mt-lg-20"></div>
        <div className="section section-sm">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="position-relative text-center">
                    <div className="bg-mask-wraper h-400px h-xl-500px mx-auto mt-n10p">
                      <div className="blend-around-huge bg-mask bg-primary bg-opacity-20"></div>
                      <div className="bg-pattern-noise blend-around-huge bg-mask opacity-70"></div>
                    </div>
                    <div className="position-relative">
                      <h2 className="title text-title text-pretty fs-2">
                        One platform to decode your marketing ROI
                      </h2>
                      <p className="fs-8 w-lg-50 mx-auto">
                        Measurement, modeling, and budget recommendations in one
                        place — built for marketers who have to act on the
                        result.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section-content">
            <div className="container">
              <div className="grid">
                <div className="g-col-12 g-col-lg-8 g-col-xl-6">
                  <div className="card card-blend card-blend-bottom h-100 overflow-hidden">
                    <div className="card-gfx">
                      <img
                        className="w-100"
                        src="/marketing/landing/home-platform-1.png"
                        alt=""
                      />
                    </div>
                    <div className="card-body pt-0">
                      <div className="card-content">
                        <h6 className="fs-8">
                          One view of what&#39;s driving sales
                        </h6>
                        <p className="mb-0">
                          See media investment, incremental sales, ROI, and
                          sales forecasts in a single view. Understand
                          what&#39;s driving performance across every channel —
                          at a glance.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="g-col-12 g-col-sm-6 g-col-lg-4 g-col-xl-3">
                  <div className="card card-blend card-blend-bottom h-100 overflow-hidden">
                    <div className="card-gfx">
                      <img
                        className="w-100"
                        src="/marketing/landing/home-platform-2.png"
                        alt=""
                      />
                    </div>
                    <div className="card-body pt-0">
                      <div className="card-content">
                        <h6 className="fs-8">Summary &amp; Data explorer</h6>
                        <p className="mb-0">
                          Drill into performance by channel, campaign, or any
                          dimension. Filter, sort, and export detailed data
                          tables to share with your team or stakeholders.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="g-col-12 g-col-sm-6 g-col-lg-4 g-col-xl-3">
                  <div className="card card-blend card-blend-bottom h-100 overflow-hidden">
                    <div className="card-gfx">
                      <img
                        className="w-100"
                        src="/marketing/landing/home-platform-3.png"
                        alt=""
                      />
                    </div>
                    <div className="card-body pt-0">
                      <div className="card-content">
                        <h6 className="fs-8">
                          Trends &amp; performance over time
                        </h6>
                        <p className="mb-0">
                          Track how ROI, media investment, incremental sales,
                          and cost-per-unit evolve over time. Spot patterns,
                          detect shifts, and stay ahead of seasonal changes.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="g-col-12 g-col-sm-6 g-col-lg-4 g-col-xl-3">
                  <div className="card card-blend card-blend-bottom h-100 overflow-hidden">
                    <div className="card-body pb-0">
                      <div className="card-content">
                        <h6 className="fs-8">
                          Reallocate with evidence, not instinct
                        </h6>
                        <p className="mb-0">
                          Explore dashboards and scenarios to reallocate
                          budgets, validate your spend, and fuel smarter growth
                          grounded in evidence.
                        </p>
                      </div>
                    </div>
                    <div className="card-gfx">
                      <img
                        className="w-100"
                        src="/marketing/landing/home-platform-4.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="g-col-12 g-col-sm-6 g-col-lg-4 g-col-xl-3">
                  <div className="card card-blend card-blend-bottom h-100 overflow-hidden">
                    <div className="card-body pb-0">
                      <div className="card-content">
                        <h6 className="fs-8">Every channel you run on</h6>
                        <p className="mb-0">
                          Link your advertising and KPI platforms, analytics
                          tools, and offline data — or upload files directly.
                          Everything flows into one workspace.{' '}
                          <Link
                            to="/integrations"
                            style={{ textDecoration: 'underline' }}>
                            See supported integrations
                          </Link>
                          .
                        </p>
                      </div>
                    </div>
                    <div className="card-gfx">
                      <img
                        className="w-100"
                        src="/marketing/landing/home-platform-5.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="g-col-12 g-col-lg-8 g-col-xl-6">
                  <div className="card card-blend card-blend-bottom h-100 overflow-hidden">
                    <div className="card-body pb-0">
                      <div className="card-content">
                        <h6 className="fs-8">Modelling &amp; Deep analysis</h6>
                        <p className="mb-0">
                          Explore marketing decompositions, response curves, and
                          saturation insights. Understand exactly how each
                          channel contributes to sales and where spend hits
                          diminishing returns.
                        </p>
                      </div>
                    </div>
                    <div className="card-gfx">
                      <img
                        className="w-100"
                        src="/marketing/landing/home-platform-6.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section section-sm">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="row gy-10 align-items-center justify-content-center">
                    <div className="col-lg-6 col-md-9 order-lg-last">
                      <div className="gfx d-flex justify-content-center justify-content-lg-end">
                        <img
                          className="mw-100 h-auto"
                          src="/marketing/landing/home-campaign-timing.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="text-block d-flex flex-column h-100">
                        <div className="fs-9 text-uppercase text-gradient-a w-max mb-4">
                          Turn performance data into smarter decisions
                        </div>
                        <h3 className="text-title mb-4">
                          See how campaign timing and spend saturation shape
                          your outcomes
                        </h3>
                        <p className="fs-8 text-pretty">
                          Whether you lead product or marketing, you need to
                          know when campaigns peak, when spend loses its edge,
                          and where to adjust. Yapamar puts that visibility at
                          your fingertips:
                        </p>
                        <ul className="nk-list fs-8 text-pretty gap-3 mb-4">
                          <li>
                            Flighting View: Evaluate burst versus always-on
                            approaches to discover which pacing delivers steady
                            results.
                          </li>
                          <li>
                            S-Curve Analytics: Spot diminishing returns early
                            and shift budgets before ROI starts to slide.
                          </li>
                          <li>
                            Actionable Insights: Determine the optimal timing,
                            intensity, and budget allocation for every channel.
                          </li>
                          <li>
                            Scenario Testing: Simulate spend and timing
                            alternatives to validate your plan before launch.
                          </li>
                        </ul>
                        <p className="fs-8 text-pretty">
                          Together, these views let you link timing, saturation,
                          and business impact — so every decision is backed by
                          evidence.
                        </p>
                        <ul className="nk-list-inline gap-6 ">
                          <li>
                            {' '}
                            <button
                              type="button"
                              onClick={() =>
                                open('contact', {
                                  title: 'Start Modeling',
                                  submitText: 'Submit Application',
                                })
                              }
                              className="btn btn-primary btn-lg">
                              <span>Start Modeling</span>
                            </button>{' '}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section section-sm">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="position-relative text-center">
                    <div className="fs-9 text-uppercase text-gradient-a w-max mb-4 mx-auto">
                      A few simple steps to get started
                    </div>
                    <h2 className="title text-title text-pretty fs-2">
                      How It Works
                    </h2>
                    <p className="fs-8 w-lg-50 mx-auto">
                      From raw data to actionable insights.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section-content">
            <div className="container">
              <div className="row gx-gs gy-10">
                <div className="col-md-6 col-xl-3">
                  <div className="card-blank text-center px-5 px-md-0 px-lg-9">
                    <div className="fs-9 text-uppercase fw-bold text-primary-light mb-4">
                      Step 1
                    </div>
                    <h6 className="fs-8">Connect channels</h6>
                    <p className="mb-0">
                      Link ad and{' '}
                      <Link
                        to="/integrations"
                        style={{ textDecoration: 'underline' }}>
                        analytics sources
                      </Link>
                      .
                    </p>
                  </div>
                  <div className="card card-bordered flex-grow-1 mt-6 mt-xl-3">
                    <div className="card-overlay-blend card-overlay-blend-top"></div>
                    <img
                      className="w-100 position-relative z-1"
                      src="/marketing/landing/home-how-it-works-1.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-6 col-xl-3">
                  <div className="card-blank text-center px-5 px-md-0 px-lg-9">
                    <div className="fs-9 text-uppercase fw-bold text-primary-light mb-4">
                      Step 2
                    </div>
                    <h6 className="fs-8">Upload data</h6>
                    <p className="mb-0">Import your historical performance.</p>
                  </div>
                  <div className="card card-bordered flex-grow-1 mt-6 mt-xl-3">
                    <div className="card-overlay-blend card-overlay-blend-top"></div>
                    <img
                      className="w-100 position-relative z-1"
                      src="/marketing/landing/home-how-it-works-2.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-6 col-xl-3">
                  <div className="card-blank text-center px-5 px-md-0 px-lg-9">
                    <div className="fs-9 text-uppercase fw-bold text-primary-light mb-4">
                      Step 3
                    </div>
                    <h6 className="fs-8">Campaign mapping</h6>
                    <p className="mb-0">Align naming across platforms.</p>
                  </div>
                  <div className="card card-bordered flex-grow-1 mt-6 mt-xl-3">
                    <div className="card-overlay-blend card-overlay-blend-top"></div>
                    <img
                      className="w-100 position-relative z-1"
                      src="/marketing/landing/home-how-it-works-3.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-md-6 col-xl-3">
                  <div className="card-blank text-center px-5 px-md-0 px-lg-9">
                    <div className="fs-9 text-uppercase fw-bold text-primary-light mb-4">
                      Step 4
                    </div>
                    <h6 className="fs-8">Start modelling</h6>
                    <p className="mb-0">
                      Select KPIs and run your first model.
                    </p>
                  </div>
                  <div className="card card-bordered flex-grow-1 mt-6 mt-xl-3">
                    <div className="card-overlay-blend card-overlay-blend-top"></div>
                    <img
                      className="w-100 position-relative z-1"
                      src="/marketing/landing/home-how-it-works-4_2.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section section-sm has-mask">
          <div className="bg-mask nk-star-field" data-star-count="100"></div>
          <div className="section-content">
            <div className="container">
              <div className="row gy-sm-8 justify-content-between align-items-center">
                <div className="col-lg-6">
                  <div className="gfx ms-sm-n8 me-sm-n16 my-sm-n10">
                    <img
                      src="/marketing/landing/home-scattered-data.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="text-block">
                    <div className="fs-9 text-uppercase text-gradient-a w-max mw-100 mb-4">
                      How It Helps
                    </div>
                    <h2 className="title text-gradient-heading fw-semibold fs-2 mb-4">
                      Where messy inputs become a model you can trust.
                    </h2>
                    <p className="fs-8 mb-8">
                      Online ad data, offline sales, holidays, consumer
                      confidence — Yapamar harmonizes the signals into a
                      model-ready dataset and feeds them to the modeling layer.
                      Definitions are consistent, time alignments are explicit,
                      and edge cases get handled before they ever reach the
                      chart.
                    </p>
                    <p className="fs-8 mb-8">
                      From there, every chart, model, and recommendation in the
                      platform draws from the same numbers — so the conversation
                      moves on from &ldquo;whose number is right&rdquo; to
                      &ldquo;what should we do next.&rdquo;
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section section-sm">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-8">
                  <div className="position-relative text-center">
                    <div className="fs-9 text-uppercase text-gradient-a w-max mx-auto mb-4">
                      Why choose us
                    </div>
                    <h2 className="title text-gradient-heading fw-semibold fs-3 mb-5">
                      A measurement layer you don&rsquo;t have to argue with
                    </h2>
                    <p className="fs-4 font-medium text-content angle-180 mb-0">
                      You shouldn’t need custom projects or biased dashboards to
                      know what’s working. Yapamar gives you a faster,
                      independent read on what your marketing is actually doing
                      — and where to spend next.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
